import { Route, Switch, useRouteMatch } from "react-router-dom";
import { NotFound } from "@app/shared/ErrorPages";
import {NetworkOutreachPage} from "./components/NetworkOutreachPage";
import {ExportOutreachData} from "./export/ExportOutreachData";
import { JSX } from "react";

export const NetworkOutreachRouter = (): JSX.Element => {
  const match = useRouteMatch();
  return (
    <Switch>
      <Route exact={true} path={`${match.path}`} component={NetworkOutreachPage} />
      <Route path={`${match.path}/export`} component={ExportOutreachData} />
      <Route>
        <NotFound />
      </Route>
    </Switch>
  );
}

export default NetworkOutreachRouter;